/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * CommonQR API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AnalyticsResponse,
  AuthResponse,
  BranchImportErrorResponse,
  BranchImportResponse,
  BranchListResponse,
  BranchResponse,
  CreateBranchRequest,
  CreateMasterRequest,
  ImportBranchesParams,
  ListBranchesParams,
  MasterListResponse,
  MasterResponse,
  MasterTierResponse,
  SetMasterTierRequest,
  UpdateBranchRequest,
  UpdateMasterRequest,
  BranchActionEventRequest,
  MasterAnalyticsParams,
  MasterAnalyticsResponse,
  ResolveBranchParams,
  ResolveBranchResponse,
  ResolveClosedBranchResponse,
  ResolveParams,
  ResolveResponse,
  BrandLinkListResponse,
  BrandLinkResponse,
  CreateBrandLinkRequest,
  ReorderBrandLinksRequest,
  UpdateBrandLinkRequest,
  ListThemesParams,
  MasterDetailResponse,
  ThemeIndustriesResponse,
  ThemeListResponse,
  UploadAvatarResponse,
  CreateLinkRequest,
  ErrorResponse,
  FeatureAccessGrant,
  FeatureAccessListResponse,
  FeaturesResponse,
  GrantFeatureAccessRequest,
  HealthStatus,
  ListFeatureAccessParams,
  LinkResponse,
  LoginRequest,
  ProfileResponse,
  PublicProfileResponse,
  QrResponse,
  RegisterRequest,
  SuccessResponse,
  UpdateProfileRequest,
  UserResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new user
 */
export const getRegisterUrl = () => {
  return `/api/v1/auth/register`;
};

export const register = async (
  registerRequest: RegisterRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerRequest),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterRequest>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new user
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login with email and password
 */
export const getLoginUrl = () => {
  return `/api/v1/auth/login`;
};

export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login with email and password
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/v1/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserResponse> => {
  return customFetch<UserResponse>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/v1/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get my profile
 */
export const getGetMyProfileUrl = () => {
  return `/api/v1/profile`;
};

export const getMyProfile = async (
  options?: RequestInit,
): Promise<ProfileResponse> => {
  return customFetch<ProfileResponse>(getGetMyProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyProfileQueryKey = () => {
  return [`/api/v1/profile`] as const;
};

export const getGetMyProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({
    signal,
  }) => getMyProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfile>>
>;
export type GetMyProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get my profile
 */

export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update my profile
 */
export const getUpdateProfileUrl = () => {
  return `/api/v1/profile`;
};

export const updateProfile = async (
  updateProfileRequest: UpdateProfileRequest,
  options?: RequestInit,
): Promise<ProfileResponse> => {
  return customFetch<ProfileResponse>(getUpdateProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileRequest),
  });
};

export const getUpdateProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileRequest> },
  TContext
> => {
  const mutationKey = ["updateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { data: BodyType<UpdateProfileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfile>>
>;
export type UpdateProfileMutationBody = BodyType<UpdateProfileRequest>;
export type UpdateProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update my profile
 */
export const useUpdateProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileRequest> },
  TContext
> => {
  return useMutation(getUpdateProfileMutationOptions(options));
};

/**
 * @summary Get my QR code data
 */
export const getGetMyQrUrl = () => {
  return `/api/v1/profile/qr`;
};

export const getMyQr = async (options?: RequestInit): Promise<QrResponse> => {
  return customFetch<QrResponse>(getGetMyQrUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyQrQueryKey = () => {
  return [`/api/v1/profile/qr`] as const;
};

export const getGetMyQrQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyQr>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyQr>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyQrQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyQr>>> = ({
    signal,
  }) => getMyQr({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyQr>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyQrQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyQr>>
>;
export type GetMyQrQueryError = ErrorType<unknown>;

/**
 * @summary Get my QR code data
 */

export function useGetMyQr<
  TData = Awaited<ReturnType<typeof getMyQr>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyQr>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyQrQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get my links
 */
export const getGetMyLinksUrl = () => {
  return `/api/v1/links`;
};

export const getMyLinks = async (
  options?: RequestInit,
): Promise<LinkResponse[]> => {
  return customFetch<LinkResponse[]>(getGetMyLinksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyLinksQueryKey = () => {
  return [`/api/v1/links`] as const;
};

export const getGetMyLinksQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyLinks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyLinks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyLinksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLinks>>> = ({
    signal,
  }) => getMyLinks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyLinks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyLinksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyLinks>>
>;
export type GetMyLinksQueryError = ErrorType<unknown>;

/**
 * @summary Get my links
 */

export function useGetMyLinks<
  TData = Awaited<ReturnType<typeof getMyLinks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyLinks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyLinksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a new link
 */
export const getCreateLinkUrl = () => {
  return `/api/v1/links`;
};

export const createLink = async (
  createLinkRequest: CreateLinkRequest,
  options?: RequestInit,
): Promise<LinkResponse> => {
  return customFetch<LinkResponse>(getCreateLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLinkRequest),
  });
};

export const getCreateLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLink>>,
    TError,
    { data: BodyType<CreateLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLink>>,
  TError,
  { data: BodyType<CreateLinkRequest> },
  TContext
> => {
  const mutationKey = ["createLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLink>>,
    { data: BodyType<CreateLinkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLink>>
>;
export type CreateLinkMutationBody = BodyType<CreateLinkRequest>;
export type CreateLinkMutationError = ErrorType<unknown>;

/**
 * @summary Add a new link
 */
export const useCreateLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLink>>,
    TError,
    { data: BodyType<CreateLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLink>>,
  TError,
  { data: BodyType<CreateLinkRequest> },
  TContext
> => {
  return useMutation(getCreateLinkMutationOptions(options));
};

/**
 * @summary Update a link
 */
export const getUpdateLinkUrl = (id: number) => {
  return `/api/v1/links/${id}`;
};

export const updateLink = async (
  id: number,
  createLinkRequest: CreateLinkRequest,
  options?: RequestInit,
): Promise<LinkResponse> => {
  return customFetch<LinkResponse>(getUpdateLinkUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLinkRequest),
  });
};

export const getUpdateLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLink>>,
    TError,
    { id: number; data: BodyType<CreateLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLink>>,
  TError,
  { id: number; data: BodyType<CreateLinkRequest> },
  TContext
> => {
  const mutationKey = ["updateLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLink>>,
    { id: number; data: BodyType<CreateLinkRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLink(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLink>>
>;
export type UpdateLinkMutationBody = BodyType<CreateLinkRequest>;
export type UpdateLinkMutationError = ErrorType<unknown>;

/**
 * @summary Update a link
 */
export const useUpdateLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLink>>,
    TError,
    { id: number; data: BodyType<CreateLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLink>>,
  TError,
  { id: number; data: BodyType<CreateLinkRequest> },
  TContext
> => {
  return useMutation(getUpdateLinkMutationOptions(options));
};

/**
 * @summary Delete a link
 */
export const getDeleteLinkUrl = (id: number) => {
  return `/api/v1/links/${id}`;
};

export const deleteLink = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteLinkUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLink>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLink>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLink>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLink(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLink>>
>;

export type DeleteLinkMutationError = ErrorType<unknown>;

/**
 * @summary Delete a link
 */
export const useDeleteLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLink>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLink>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteLinkMutationOptions(options));
};

/**
 * @summary Get my QR scan analytics
 */
export const getGetAnalyticsUrl = () => {
  return `/api/v1/analytics`;
};

export const getAnalytics = async (
  options?: RequestInit,
): Promise<AnalyticsResponse> => {
  return customFetch<AnalyticsResponse>(getGetAnalyticsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsQueryKey = () => {
  return [`/api/v1/analytics`] as const;
};

export const getGetAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnalytics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytics>>> = ({
    signal,
  }) => getAnalytics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalytics>>
>;
export type GetAnalyticsQueryError = ErrorType<unknown>;

/**
 * @summary Get my QR scan analytics
 */

export function useGetAnalytics<
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnalytics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get public profile by username
 */
export const getGetPublicProfileUrl = (username: string) => {
  return `/api/v1/p/${username}`;
};

export const getPublicProfile = async (
  username: string,
  options?: RequestInit,
): Promise<PublicProfileResponse> => {
  return customFetch<PublicProfileResponse>(getGetPublicProfileUrl(username), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicProfileQueryKey = (username: string) => {
  return [`/api/v1/p/${username}`] as const;
};

export const getGetPublicProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  username: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicProfileQueryKey(username);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicProfile>>
  > = ({ signal }) => getPublicProfile(username, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!username,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicProfile>>
>;
export type GetPublicProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get public profile by username
 */

export function useGetPublicProfile<
  TData = Awaited<ReturnType<typeof getPublicProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  username: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicProfileQueryOptions(username, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record a QR code scan
 */
export const getRecordScanUrl = (username: string) => {
  return `/api/v1/p/${username}/scan`;
};

export const recordScan = async (
  username: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRecordScanUrl(username), {
    ...options,
    method: "POST",
  });
};

export const getRecordScanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordScan>>,
    TError,
    { username: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordScan>>,
  TError,
  { username: string },
  TContext
> => {
  const mutationKey = ["recordScan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordScan>>,
    { username: string }
  > = (props) => {
    const { username } = props ?? {};

    return recordScan(username, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordScan>>
>;

export type RecordScanMutationError = ErrorType<unknown>;

/**
 * @summary Record a QR code scan
 */
export const useRecordScan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordScan>>,
    TError,
    { username: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordScan>>,
  TError,
  { username: string },
  TContext
> => {
  return useMutation(getRecordScanMutationOptions(options));
};

/**
 * @summary Feature flag keys enabled for the caller (login optional)
 */
export const getGetFeaturesUrl = () => {
  return `/api/v1/features`;
};

export const getFeatures = async (
  options?: RequestInit,
): Promise<FeaturesResponse> => {
  return customFetch<FeaturesResponse>(getGetFeaturesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFeaturesQueryKey = () => {
  return [`/api/v1/features`] as const;
};

export const getGetFeaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeatures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeatures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeaturesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatures>>> = ({
    signal,
  }) => getFeatures({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeatures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeatures>>
>;
export type GetFeaturesQueryError = ErrorType<unknown>;

/**
 * @summary Feature flag keys enabled for the caller (login optional)
 */

export function useGetFeatures<
  TData = Awaited<ReturnType<typeof getFeatures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFeatures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeaturesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List Beta access grants (super admin)
 */
export const getListFeatureAccessUrl = (params?: ListFeatureAccessParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/feature-access?${stringifiedParams}`
    : `/api/v1/admin/feature-access`;
};

export const listFeatureAccess = async (
  params?: ListFeatureAccessParams,
  options?: RequestInit,
): Promise<FeatureAccessListResponse> => {
  return customFetch<FeatureAccessListResponse>(
    getListFeatureAccessUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListFeatureAccessQueryKey = (
  params?: ListFeatureAccessParams,
) => {
  return [`/api/v1/admin/feature-access`, ...(params ? [params] : [])] as const;
};

export const getListFeatureAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof listFeatureAccess>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListFeatureAccessParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFeatureAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFeatureAccessQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFeatureAccess>>
  > = ({ signal }) => listFeatureAccess(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFeatureAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFeatureAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFeatureAccess>>
>;
export type ListFeatureAccessQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List Beta access grants (super admin)
 */

export function useListFeatureAccess<
  TData = Awaited<ReturnType<typeof listFeatureAccess>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListFeatureAccessParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFeatureAccess>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFeatureAccessQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Grant (or re-activate) Beta access for a user (super admin)
 */
export const getGrantFeatureAccessUrl = () => {
  return `/api/v1/admin/feature-access`;
};

export const grantFeatureAccess = async (
  grantFeatureAccessRequest: GrantFeatureAccessRequest,
  options?: RequestInit,
): Promise<FeatureAccessGrant> => {
  return customFetch<FeatureAccessGrant>(getGrantFeatureAccessUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(grantFeatureAccessRequest),
  });
};

export const getGrantFeatureAccessMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantFeatureAccess>>,
    TError,
    { data: BodyType<GrantFeatureAccessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantFeatureAccess>>,
  TError,
  { data: BodyType<GrantFeatureAccessRequest> },
  TContext
> => {
  const mutationKey = ["grantFeatureAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantFeatureAccess>>,
    { data: BodyType<GrantFeatureAccessRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return grantFeatureAccess(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantFeatureAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantFeatureAccess>>
>;
export type GrantFeatureAccessMutationBody = BodyType<GrantFeatureAccessRequest>;
export type GrantFeatureAccessMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Grant (or re-activate) Beta access for a user (super admin)
 */
export const useGrantFeatureAccess = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantFeatureAccess>>,
    TError,
    { data: BodyType<GrantFeatureAccessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof grantFeatureAccess>>,
  TError,
  { data: BodyType<GrantFeatureAccessRequest> },
  TContext
> => {
  return useMutation(getGrantFeatureAccessMutationOptions(options));
};

/**
 * @summary Revoke a Beta access grant (super admin)
 */
export const getRevokeFeatureAccessUrl = (id: number) => {
  return `/api/v1/admin/feature-access/${id}/revoke`;
};

export const revokeFeatureAccess = async (
  id: number,
  options?: RequestInit,
): Promise<FeatureAccessGrant> => {
  return customFetch<FeatureAccessGrant>(getRevokeFeatureAccessUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRevokeFeatureAccessMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeFeatureAccess>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeFeatureAccess>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeFeatureAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeFeatureAccess>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeFeatureAccess(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeFeatureAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeFeatureAccess>>
>;

export type RevokeFeatureAccessMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Revoke a Beta access grant (super admin)
 */
export const useRevokeFeatureAccess = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeFeatureAccess>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeFeatureAccess>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeFeatureAccessMutationOptions(options));
};

// ═══ Masters and branches (MP-07a) — hand-maintained ═════════════════════════
// Behind the product_branches flag (product Masters also need product_products):
// callers without access get the app's normal 404.

const jsonInit = (method: string, body: unknown, options?: RequestInit): RequestInit => ({
  ...options,
  method,
  headers: { "Content-Type": "application/json", ...options?.headers },
  body: JSON.stringify(body),
});

const queryString = (params?: Record<string, string | undefined>) => {
  const q = new URLSearchParams();
  Object.entries(params ?? {}).forEach(([k, v]) => { if (v !== undefined) q.append(k, v); });
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const getListMastersUrl = () => `/api/v1/masters`;
export const getMasterUrl = (id: string) => `/api/v1/masters/${encodeURIComponent(id)}`;
export const getMasterBranchesUrl = (id: string, params?: ListBranchesParams) =>
  `/api/v1/masters/${encodeURIComponent(id)}/branches${queryString(params)}`;
export const getMasterBranchUrl = (id: string, branchId: string) =>
  `/api/v1/masters/${encodeURIComponent(id)}/branches/${encodeURIComponent(branchId)}`;
export const getBranchImportTemplateUrl = (id: string) =>
  `/api/v1/masters/${encodeURIComponent(id)}/branches/import-template`;
export const getImportBranchesUrl = (id: string, params?: ImportBranchesParams) =>
  `/api/v1/masters/${encodeURIComponent(id)}/branches/import${queryString(params)}`;
export const getSetMasterTierUrl = (id: string) => `/api/v1/admin/masters/${encodeURIComponent(id)}/tier`;

/** @summary List my Masters */
export const listMasters = (options?: RequestInit): Promise<MasterListResponse> =>
  customFetch<MasterListResponse>(getListMastersUrl(), { ...options, method: "GET" });

/** @summary Create a Master (brand, or product under one of my brands) */
export const createMaster = (body: CreateMasterRequest, options?: RequestInit): Promise<MasterResponse> =>
  customFetch<MasterResponse>(getListMastersUrl(), jsonInit("POST", body, options));

/** @summary Get one of my Masters, with its content profile's editable fields */
export const getMaster = (id: string, options?: RequestInit): Promise<MasterDetailResponse> =>
  customFetch<MasterDetailResponse>(getMasterUrl(id), { ...options, method: "GET" });

/** @summary Update a Master (displayName, whiteLabel, status). Archiving never releases the handle. */
export const updateMaster = (id: string, body: UpdateMasterRequest, options?: RequestInit): Promise<MasterResponse> =>
  customFetch<MasterResponse>(getMasterUrl(id), jsonInit("PATCH", body, options));

/** @summary Set a Master's branch tier (super admin) */
export const setMasterTier = (id: string, body: SetMasterTierRequest, options?: RequestInit): Promise<MasterTierResponse> =>
  customFetch<MasterTierResponse>(getSetMasterTierUrl(id), jsonInit("PATCH", body, options));

/** @summary List a brand Master's branches */
export const listMasterBranches = (id: string, params?: ListBranchesParams, options?: RequestInit): Promise<BranchListResponse> =>
  customFetch<BranchListResponse>(getMasterBranchesUrl(id, params), { ...options, method: "GET" });

/** @summary Create a branch (within the Master's tier) */
export const createBranch = (id: string, body: CreateBranchRequest, options?: RequestInit): Promise<BranchResponse> =>
  customFetch<BranchResponse>(getMasterBranchesUrl(id), jsonInit("POST", body, options));

/** @summary Update a branch (the slug can't change) */
export const updateBranch = (id: string, branchId: string, body: UpdateBranchRequest, options?: RequestInit): Promise<BranchResponse> =>
  customFetch<BranchResponse>(getMasterBranchUrl(id, branchId), jsonInit("PATCH", body, options));

/** @summary Archive a branch (no hard delete exists) */
export const archiveBranch = (id: string, branchId: string, options?: RequestInit): Promise<BranchResponse> =>
  customFetch<BranchResponse>(`${getMasterBranchUrl(id, branchId)}/archive`, { ...options, method: "POST" });

/** @summary Restore an archived branch (within the Master's tier) */
export const restoreBranch = (id: string, branchId: string, options?: RequestInit): Promise<BranchResponse> =>
  customFetch<BranchResponse>(`${getMasterBranchUrl(id, branchId)}/restore`, { ...options, method: "POST" });

/** @summary Download the .xlsx branch import template */
export const downloadBranchImportTemplate = (id: string, options?: RequestInit): Promise<Blob> =>
  customFetch<Blob>(getBranchImportTemplateUrl(id), { ...options, method: "GET", responseType: "blob" });

/** @summary Import branches from .xlsx or .csv (≤ 2 MB); all-or-nothing; dryRun validates only */
export const importBranches = (id: string, file: Blob, fileName: string, params?: ImportBranchesParams, options?: RequestInit): Promise<BranchImportResponse> => {
  const form = new FormData();
  form.append("file", file, fileName);
  return customFetch<BranchImportResponse>(getImportBranchesUrl(id, params), { ...options, method: "POST", body: form });
};

export const getListMastersQueryKey = () => [`/api/v1/masters`] as const;
export const getMasterQueryKey = (id: string) => [`/api/v1/masters`, id] as const;
export const getMasterBranchesQueryKey = (id: string, params?: ListBranchesParams) =>
  [`/api/v1/masters`, id, "branches", ...(params ? [params] : [])] as const;

export function useListMasters<TData = MasterListResponse, TError = ErrorType<ErrorResponse>>(options?: {
  query?: Partial<UseQueryOptions<MasterListResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getListMastersQueryKey();
  const queryFn: QueryFunction<MasterListResponse> = ({ signal }) => listMasters({ signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, ...options?.query } as UseQueryOptions<MasterListResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export function useGetMaster<TData = MasterDetailResponse, TError = ErrorType<ErrorResponse>>(id: string, options?: {
  query?: Partial<UseQueryOptions<MasterDetailResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getMasterQueryKey(id);
  const queryFn: QueryFunction<MasterDetailResponse> = ({ signal }) => getMaster(id, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!id, ...options?.query } as UseQueryOptions<MasterDetailResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export function useListMasterBranches<TData = BranchListResponse, TError = ErrorType<ErrorResponse>>(id: string, params?: ListBranchesParams, options?: {
  query?: Partial<UseQueryOptions<BranchListResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getMasterBranchesQueryKey(id, params);
  const queryFn: QueryFunction<BranchListResponse> = ({ signal }) => listMasterBranches(id, params, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!id, ...options?.query } as UseQueryOptions<BranchListResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

type MutationHookOptions<TResult, TVars, TError, TContext> = {
  mutation?: UseMutationOptions<TResult, TError, TVars, TContext>;
};

export const useCreateMaster = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<MasterResponse, { data: BodyType<CreateMasterRequest> }, TError, TContext>,
): UseMutationResult<MasterResponse, TError, { data: BodyType<CreateMasterRequest> }, TContext> =>
  useMutation({ mutationKey: ["createMaster"], mutationFn: ({ data }) => createMaster(data), ...options?.mutation });

export const useUpdateMaster = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<MasterResponse, { id: string; data: BodyType<UpdateMasterRequest> }, TError, TContext>,
): UseMutationResult<MasterResponse, TError, { id: string; data: BodyType<UpdateMasterRequest> }, TContext> =>
  useMutation({ mutationKey: ["updateMaster"], mutationFn: ({ id, data }) => updateMaster(id, data), ...options?.mutation });

export const useSetMasterTier = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<MasterTierResponse, { id: string; data: BodyType<SetMasterTierRequest> }, TError, TContext>,
): UseMutationResult<MasterTierResponse, TError, { id: string; data: BodyType<SetMasterTierRequest> }, TContext> =>
  useMutation({ mutationKey: ["setMasterTier"], mutationFn: ({ id, data }) => setMasterTier(id, data), ...options?.mutation });

export const useCreateBranch = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BranchResponse, { id: string; data: BodyType<CreateBranchRequest> }, TError, TContext>,
): UseMutationResult<BranchResponse, TError, { id: string; data: BodyType<CreateBranchRequest> }, TContext> =>
  useMutation({ mutationKey: ["createBranch"], mutationFn: ({ id, data }) => createBranch(id, data), ...options?.mutation });

export const useUpdateBranch = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BranchResponse, { id: string; branchId: string; data: BodyType<UpdateBranchRequest> }, TError, TContext>,
): UseMutationResult<BranchResponse, TError, { id: string; branchId: string; data: BodyType<UpdateBranchRequest> }, TContext> =>
  useMutation({ mutationKey: ["updateBranch"], mutationFn: ({ id, branchId, data }) => updateBranch(id, branchId, data), ...options?.mutation });

export const useArchiveBranch = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BranchResponse, { id: string; branchId: string }, TError, TContext>,
): UseMutationResult<BranchResponse, TError, { id: string; branchId: string }, TContext> =>
  useMutation({ mutationKey: ["archiveBranch"], mutationFn: ({ id, branchId }) => archiveBranch(id, branchId), ...options?.mutation });

export const useRestoreBranch = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BranchResponse, { id: string; branchId: string }, TError, TContext>,
): UseMutationResult<BranchResponse, TError, { id: string; branchId: string }, TContext> =>
  useMutation({ mutationKey: ["restoreBranch"], mutationFn: ({ id, branchId }) => restoreBranch(id, branchId), ...options?.mutation });

export const useImportBranches = <TError = ErrorType<BranchImportErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BranchImportResponse, { id: string; file: Blob; fileName: string; params?: ImportBranchesParams }, TError, TContext>,
): UseMutationResult<BranchImportResponse, TError, { id: string; file: Blob; fileName: string; params?: ImportBranchesParams }, TContext> =>
  useMutation({ mutationKey: ["importBranches"], mutationFn: ({ id, file, fileName, params }) => importBranches(id, file, fileName, params), ...options?.mutation });

// ═══ Public resolver, branch events, Master analytics (MP-07b) — hand-maintained ═
// Master pages, branch pages, events and analytics are viewer-gated (product_branches; product Masters
// also need product_products): hidden ones answer exactly like an unknown handle (404).

export const getResolveUrl = (handle: string, params?: ResolveParams) =>
  `/api/v1/resolve/${encodeURIComponent(handle)}${queryString(params)}`;
export const getResolveBranchUrl = (handle: string, branchSlug: string, params?: ResolveBranchParams) =>
  `/api/v1/resolve/${encodeURIComponent(handle)}/${encodeURIComponent(branchSlug)}${queryString(params)}`;
export const getBranchEventsUrl = () => `/api/v1/events`;
export const getMasterAnalyticsUrl = (id: string, params?: MasterAnalyticsParams) =>
  `/api/v1/masters/${encodeURIComponent(id)}/analytics${queryString(params)}`;

/** @summary Resolve commonqr.com/{handle}: a Card profile or a Master page (nearest three branches) */
export const resolveHandle = (handle: string, params?: ResolveParams, options?: RequestInit): Promise<ResolveResponse> =>
  customFetch<ResolveResponse>(getResolveUrl(handle, params), { ...options, method: "GET" });

/** @summary Resolve commonqr.com/{brand}/{branch}: a branch page (or a closed-branch page) */
export const resolveBranch = (
  handle: string, branchSlug: string, params?: ResolveBranchParams, options?: RequestInit,
): Promise<ResolveBranchResponse | ResolveClosedBranchResponse> =>
  customFetch<ResolveBranchResponse | ResolveClosedBranchResponse>(getResolveBranchUrl(handle, branchSlug, params), { ...options, method: "GET" });

/** @summary Record a call / WhatsApp / directions tap on an active branch (204) */
export const recordBranchEvent = (body: BranchActionEventRequest, options?: RequestInit): Promise<void> =>
  customFetch<void>(getBranchEventsUrl(), jsonInit("POST", body, options));

/** @summary Owner analytics for a Master (UTC days) */
export const getMasterAnalytics = (id: string, params?: MasterAnalyticsParams, options?: RequestInit): Promise<MasterAnalyticsResponse> =>
  customFetch<MasterAnalyticsResponse>(getMasterAnalyticsUrl(id, params), { ...options, method: "GET" });

export const getResolveQueryKey = (handle: string, params?: ResolveParams) =>
  [`/api/v1/resolve`, handle, ...(params ? [params] : [])] as const;
export const getResolveBranchQueryKey = (handle: string, branchSlug: string, params?: ResolveBranchParams) =>
  [`/api/v1/resolve`, handle, branchSlug, ...(params ? [params] : [])] as const;
export const getMasterAnalyticsQueryKey = (id: string, params?: MasterAnalyticsParams) =>
  [`/api/v1/masters`, id, "analytics", ...(params ? [params] : [])] as const;

export function useResolveHandle<TData = ResolveResponse, TError = ErrorType<ErrorResponse>>(handle: string, params?: ResolveParams, options?: {
  query?: Partial<UseQueryOptions<ResolveResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getResolveQueryKey(handle, params);
  const queryFn: QueryFunction<ResolveResponse> = ({ signal }) => resolveHandle(handle, params, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!handle, ...options?.query } as UseQueryOptions<ResolveResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export function useResolveBranch<
  TData = ResolveBranchResponse | ResolveClosedBranchResponse, TError = ErrorType<ErrorResponse>,
>(handle: string, branchSlug: string, params?: ResolveBranchParams, options?: {
  query?: Partial<UseQueryOptions<ResolveBranchResponse | ResolveClosedBranchResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getResolveBranchQueryKey(handle, branchSlug, params);
  const queryFn: QueryFunction<ResolveBranchResponse | ResolveClosedBranchResponse> = ({ signal }) =>
    resolveBranch(handle, branchSlug, params, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!handle && !!branchSlug, ...options?.query } as UseQueryOptions<ResolveBranchResponse | ResolveClosedBranchResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export function useGetMasterAnalytics<TData = MasterAnalyticsResponse, TError = ErrorType<ErrorResponse>>(id: string, params?: MasterAnalyticsParams, options?: {
  query?: Partial<UseQueryOptions<MasterAnalyticsResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getMasterAnalyticsQueryKey(id, params);
  const queryFn: QueryFunction<MasterAnalyticsResponse> = ({ signal }) => getMasterAnalytics(id, params, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!id, ...options?.query } as UseQueryOptions<MasterAnalyticsResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export const useRecordBranchEvent = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<void, { data: BodyType<BranchActionEventRequest> }, TError, TContext>,
): UseMutationResult<void, TError, { data: BodyType<BranchActionEventRequest> }, TContext> =>
  useMutation({ mutationKey: ["recordBranchEvent"], mutationFn: ({ data }) => recordBranchEvent(data), ...options?.mutation });

// ═══ Brand links (MP-08b-api) — hand-maintained ═══════════════════════════════
// Owner only, same gating as the Master. Writes on an archived Master answer 400 (MasterArchived).

export const getMasterLinksUrl = (id: string) => `/api/v1/masters/${encodeURIComponent(id)}/links`;
export const getMasterLinkUrl = (id: string, linkId: number) => `${getMasterLinksUrl(id)}/${encodeURIComponent(String(linkId))}`;

/** @summary List a Master's brand links, in order */
export const listMasterLinks = (id: string, options?: RequestInit): Promise<BrandLinkListResponse> =>
  customFetch<BrandLinkListResponse>(getMasterLinksUrl(id), { ...options, method: "GET" });

/** @summary Add a brand link (appended at the end) */
export const createMasterLink = (id: string, body: CreateBrandLinkRequest, options?: RequestInit): Promise<BrandLinkResponse> =>
  customFetch<BrandLinkResponse>(getMasterLinksUrl(id), jsonInit("POST", body, options));

/** @summary Edit a brand link */
export const updateMasterLink = (id: string, linkId: number, body: UpdateBrandLinkRequest, options?: RequestInit): Promise<BrandLinkResponse> =>
  customFetch<BrandLinkResponse>(getMasterLinkUrl(id, linkId), jsonInit("PATCH", body, options));

/** @summary Delete a brand link */
export const deleteMasterLink = (id: string, linkId: number, options?: RequestInit): Promise<SuccessResponse> =>
  customFetch<SuccessResponse>(getMasterLinkUrl(id, linkId), { ...options, method: "DELETE" });

/** @summary Reorder brand links: every id exactly once */
export const reorderMasterLinks = (id: string, body: ReorderBrandLinksRequest, options?: RequestInit): Promise<BrandLinkListResponse> =>
  customFetch<BrandLinkListResponse>(`${getMasterLinksUrl(id)}/order`, jsonInit("PUT", body, options));

export const getMasterLinksQueryKey = (id: string) => [`/api/v1/masters`, id, "links"] as const;

export function useListMasterLinks<TData = BrandLinkListResponse, TError = ErrorType<ErrorResponse>>(id: string, options?: {
  query?: Partial<UseQueryOptions<BrandLinkListResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getMasterLinksQueryKey(id);
  const queryFn: QueryFunction<BrandLinkListResponse> = ({ signal }) => listMasterLinks(id, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, enabled: !!id, ...options?.query } as UseQueryOptions<BrandLinkListResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export const useCreateMasterLink = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BrandLinkResponse, { id: string; data: BodyType<CreateBrandLinkRequest> }, TError, TContext>,
): UseMutationResult<BrandLinkResponse, TError, { id: string; data: BodyType<CreateBrandLinkRequest> }, TContext> =>
  useMutation({ mutationKey: ["createMasterLink"], mutationFn: ({ id, data }) => createMasterLink(id, data), ...options?.mutation });

export const useUpdateMasterLink = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BrandLinkResponse, { id: string; linkId: number; data: BodyType<UpdateBrandLinkRequest> }, TError, TContext>,
): UseMutationResult<BrandLinkResponse, TError, { id: string; linkId: number; data: BodyType<UpdateBrandLinkRequest> }, TContext> =>
  useMutation({ mutationKey: ["updateMasterLink"], mutationFn: ({ id, linkId, data }) => updateMasterLink(id, linkId, data), ...options?.mutation });

export const useDeleteMasterLink = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<SuccessResponse, { id: string; linkId: number }, TError, TContext>,
): UseMutationResult<SuccessResponse, TError, { id: string; linkId: number }, TContext> =>
  useMutation({ mutationKey: ["deleteMasterLink"], mutationFn: ({ id, linkId }) => deleteMasterLink(id, linkId), ...options?.mutation });

export const useReorderMasterLinks = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<BrandLinkListResponse, { id: string; data: BodyType<ReorderBrandLinksRequest> }, TError, TContext>,
): UseMutationResult<BrandLinkListResponse, TError, { id: string; data: BodyType<ReorderBrandLinksRequest> }, TContext> =>
  useMutation({ mutationKey: ["reorderMasterLinks"], mutationFn: ({ id, data }) => reorderMasterLinks(id, data), ...options?.mutation });

// ═══ Owner-screen gaps (MP-08b-api D) — hand-maintained ═══════════════════════
// The brand card editor reuses the Card's endpoints: upload the avatar, then updateProfile({ profileId, avatarUrl }).

export const getUploadAvatarUrl = () => `/api/v1/profile/avatar`;
export const getThemesUrl = (params?: ListThemesParams) => `/api/v1/themes${queryString(params)}`;
export const getThemeIndustriesUrl = () => `/api/v1/themes/industries`;

/** @summary Upload an avatar image (image/*, at most 5 MB); returns its URL, saved nowhere until updateProfile */
export const uploadAvatar = (file: Blob, fileName: string, options?: RequestInit): Promise<UploadAvatarResponse> => {
  const form = new FormData();
  form.append("avatar", file, fileName);
  return customFetch<UploadAvatarResponse>(getUploadAvatarUrl(), { ...options, method: "POST", body: form });
};

/** @summary Active themes (all free on every plan), filtered by industry / variant */
export const listThemes = (params?: ListThemesParams, options?: RequestInit): Promise<ThemeListResponse> =>
  customFetch<ThemeListResponse>(getThemesUrl(params), { ...options, method: "GET" });

/** @summary Industries that have active themes */
export const listThemeIndustries = (options?: RequestInit): Promise<ThemeIndustriesResponse> =>
  customFetch<ThemeIndustriesResponse>(getThemeIndustriesUrl(), { ...options, method: "GET" });

export const getThemesQueryKey = (params?: ListThemesParams) => [`/api/v1/themes`, ...(params ? [params] : [])] as const;
export const getThemeIndustriesQueryKey = () => [`/api/v1/themes/industries`] as const;

export function useListThemes<TData = ThemeListResponse, TError = ErrorType<ErrorResponse>>(params?: ListThemesParams, options?: {
  query?: Partial<UseQueryOptions<ThemeListResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getThemesQueryKey(params);
  const queryFn: QueryFunction<ThemeListResponse> = ({ signal }) => listThemes(params, { signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, ...options?.query } as UseQueryOptions<ThemeListResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export function useListThemeIndustries<TData = ThemeIndustriesResponse, TError = ErrorType<ErrorResponse>>(options?: {
  query?: Partial<UseQueryOptions<ThemeIndustriesResponse, TError, TData>>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryKey = options?.query?.queryKey ?? getThemeIndustriesQueryKey();
  const queryFn: QueryFunction<ThemeIndustriesResponse> = ({ signal }) => listThemeIndustries({ signal, ...options?.request });
  const query = useQuery({ queryKey, queryFn, ...options?.query } as UseQueryOptions<ThemeIndustriesResponse, TError, TData>);
  return { ...query, queryKey } as UseQueryResult<TData, TError> & { queryKey: QueryKey };
}

export const useUploadAvatar = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: MutationHookOptions<UploadAvatarResponse, { file: Blob; fileName: string }, TError, TContext>,
): UseMutationResult<UploadAvatarResponse, TError, { file: Blob; fileName: string }, TContext> =>
  useMutation({ mutationKey: ["uploadAvatar"], mutationFn: ({ file, fileName }) => uploadAvatar(file, fileName), ...options?.mutation });
